import { SearchFieldOption } from 'components/2-molecules/SearchFieldComponent/SearchFieldComponent';
import { FieldValues, UseFormRegister } from 'react-hook-form';
import { apiInstance, apiInstanceCached } from '../services/Api';
import { FrontendDatasourceEvent, HttpMethod, SearchComponent, SearchConfiguration } from './SearchConfiguration';

// [
// 	{
//     "tekst": "1200 København K",
//     "postnummer": {
//         "nr": "1200",
//         "navn": "København K",
//         "stormodtager": false,
//         "visueltcenter_x": 12.5798222,
//         "visueltcenter_y": 55.67820341,
//         "href": "https://api.dataforsyningen.dk/postnumre/1200"
//     }
// }
// ]

// [
// {
//     "data": {
//         "id": "0a3f507b-cc63-32b8-e044-0003ba298018",
//         "status": 1,
//         "darstatus": 3,
//         "vejkode": "0001",
//         "vejnavn": "Adolphsvej",
//         "adresseringsvejnavn": "Adolphsvej",
//         "husnr": "19",
//         "supplerendebynavn": null,
//         "postnr": "2820",
//         "postnrnavn": "Gentofte",
//         "stormodtagerpostnr": null,
//         "stormodtagerpostnrnavn": null,
//         "kommunekode": "0157",
//         "x": 12.5535414,
//         "y": 55.74751978,
//         "href": "https://api.dataforsyningen.dk/adgangsadresser/0a3f507b-cc63-32b8-e044-0003ba298018"
//     },
//     "stormodtagerpostnr": false,
//     "type": "adgangsadresse",
//     "tekst": "Adolphsvej 19, , 2820 Gentofte",
//     "forslagstekst": "Adolphsvej 19, 2820 Gentofte",
//     "caretpos": 15
// }
// ]
export class ZipcodeAddressSearch implements SearchComponent {
	searchConfiguration: SearchConfiguration;
	secondarySearchConfiguration: SearchConfiguration;
	apiSearch: boolean;
	isZipcodeSearch: boolean;
	minInputLength: number;
	hasHadResult: boolean;
	searchIcon: string;
	lastValue: string;
	latency: number;

	constructor(searchConfiguration: SearchConfiguration) {
		this.searchConfiguration = searchConfiguration;
		this.apiSearch = true;
		this.isZipcodeSearch = searchConfiguration.frontendDatasourceEvent === FrontendDatasourceEvent.ZIPCODE;
		this.minInputLength = this.isZipcodeSearch ? 1 : 2;
		this.searchIcon = 'map-pin';
		this.latency = 100;

		// SPD kvhx search
		this.secondarySearchConfiguration = {
			frontendDatasourceEvent: FrontendDatasourceEvent.SPD_ZIPCODE_ADDRESS,
			httpMethod: HttpMethod.POST,
			url: '/api/aquaman/v1/openserviceproxy/sales-ui/api-tn2/v1/services/interface',
		};
	}

	init = async (): Promise<SearchFieldOption[]> => {
		return undefined;
	};

	handleInputChange = async (value: string): Promise<SearchFieldOption[]> => {
		if (value?.trim().length >= this.minInputLength) {
			this.lastValue = value;
			await new Promise((res) => setTimeout(res, this.latency));
			if (this.lastValue !== value) {
				// a new typing overrides this
				return;
			}

			const options: SearchFieldOption[] = [];
			try {
				const res: any = await apiInstance().get(this.searchConfiguration.url + encodeURI(value));

				res?.forEach((element) => {
					this.hasHadResult = true;
					if (this.isZipcodeSearch) {
						options.push({
							label: element.tekst,
							value: element.postnummer?.nr,
						});
					} else {
						options.push({
							label: element.forslagstekst,
							value: JSON.stringify(element.data), //element.data.href,
						});
					}
				});
			} catch (error) {
				console.error(error);
			}
			return options;
		}
		return this.hasHadResult ? [] : undefined;
	};

	handleChange = async (option: SearchFieldOption): Promise<SearchFieldOption> => {
		if (!this.isZipcodeSearch) {
			// add kvh or kvhx from DAWA to address object
			const data = JSON.parse(option.value);
			if (data.href) {
				const resKvhx: any = await apiInstance().get(data.href);
				if (resKvhx) {
					data.kvhx = resKvhx.kvhx ?? resKvhx.kvh;
					option.value = JSON.stringify(data);
				}
			}
		}
		return option;
	};

	handleSecondaryChange = async (
		option: SearchFieldOption,
		register: UseFormRegister<FieldValues>
	): Promise<void> => {
		// const isLoggedIn = store.getState().customer.isLoggedIn;
		// if (isLoggedIn) {
		// 	return Promise.resolve();
		// }

		// POST REQUEST
		// {
		// call: {
		// 	URL: 'GET /tiainterface/api/v1/general/anyobject/AGT_LOCADR',
		// 	name: 'general default - AGT_LOCADR2',
		// 	params: {
		// 		LOCATION_ADDRESS: encodeURI(option.label),
		// 	},
		// },
		// searchConfiguration: {},
		// }

		// POST RESPONSE
		// {
		// 	"data": {
		// 		"URL": "GET /tiainterface/api/v1/general/anyobject/AGT_LOCADR",
		// 		"name": "default",
		// 		"response": {
		// 			"VALUE": 9652502119
		// 		}
		// 	},
		// 	"successful": true
		// }
		// await new Promise((reg) => setTimeout(reg, 2000));
		let kvhxValue = '';
		try {
			const res: any = await apiInstanceCached().post(this.secondarySearchConfiguration.url, {
				call: {
					URL: 'GET /tiainterface/api/v1/general/anyobject/AGT_LOCADR',
					name: 'general default - AGT_LOCADR2',
					params: {
						LOCATION_ADDRESS: encodeURI(option.label),
					},
				},
				searchConfiguration: {},
			});

			kvhxValue = res?.data?.VALUE;
		} catch (error) {
			console.error(error);
			kvhxValue = '9652502119'; // 4320 Lejre
			console.warn('setting kvhx value hardCoded', kvhxValue);
		}

		const PREFIX = 'PT_PTL01_PTO01_'; // TODO Get from metaInfo
		const kvhxName = PREFIX + 'GEO_KVHX';
		const { onChange } = register(kvhxName, { required: true });
		await onChange({
			target: {
				name: kvhxName,
				value: {
					id: kvhxName,
					value: kvhxValue,
					label: kvhxValue,
					stepTitle: 'Kvhx',
					type: 'SearchFieldBlock',
				},
			},
		});

		const countryCode = PREFIX + 'COUNTRY_CODE';
		const countryCodeValue = 'DK';
		const { onChange: onChangeCountry } = register(countryCode, { required: true });
		await onChangeCountry({
			target: {
				name: countryCode,
				value: {
					id: countryCode,
					value: countryCodeValue,
					label: countryCodeValue,
					stepTitle: 'Landekode',
					type: 'SearchFieldBlock',
				},
			},
		});
	};
}
